"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldInputCoreInputs = exports.NativeInputCoreInputs = void 0;
const datepicker_inputs_1 = require("../datepicker/datepicker.inputs");
const input_type_1 = require("./input.type");
class NativeInputCoreInputs {
    constructor() {
        this.id = `${Math.floor(Math.random() * 10000)}`;
        this.readOnly = false;
    }
}
exports.NativeInputCoreInputs = NativeInputCoreInputs;
class EmeraldInputCoreInputs extends datepicker_inputs_1.EmeraldDatepickerSharedInputs {
    constructor() {
        super(...arguments);
        this.type = input_type_1.EmeraldInputType.Text;
        this.id = `${Math.floor(Math.random() * 10000)}`;
        this.readOnly = false;
        this.outlined = true;
        this.useNativeValidation = true;
        this.showClearIcon = false; // for text, number, date & textarea type
        this.rows = 3; // for text area
        this.inputSize = 'medium';
        this.asterisk = true;
    }
}
exports.EmeraldInputCoreInputs = EmeraldInputCoreInputs;
//# sourceMappingURL=input.inputs.js.map